import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

export type FilterBy = 'Department' | 'Division' | 'Entity' | 'JobLevel' | 'Location' | 'Team' | 'Title';

type AutocompletionDto = {
    id: FilterBy;
    values: string[];
};

export function reviewCycleAutocompleteSuggestions(filterBy: FilterBy, reviewCycleId: string): Promise<string[]> {
    return get(`${API_URL}/autocomplete-suggestions/review/${reviewCycleId}/${filterBy}`);
}

companyAutocompleteSuggestions.operation = 'READ';
companyAutocompleteSuggestions.byId = true;
export function companyAutocompleteSuggestions(filterBy: FilterBy): Promise<AutocompletionDto> {
    return get<string[]>(`${API_URL}/autocomplete-suggestions/${filterBy}`).then(values => ({ id: filterBy, values }));
}

getAllCompanyAutocompleteSuggestions.operation = 'READ';
export function getAllCompanyAutocompleteSuggestions() {
    return get<AutocompletionDto[]>(`${API_URL}/autocomplete-suggestions`);
}
